module.exports = __webpack_public_path__ + "img/icon2.4a9d257a.svg";